import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import CommentCaMarche from "@/pages/CommentCaMarche";
import Annonces from "@/pages/Annonces";
import AnnonceDetail from "@/pages/AnnonceDetail";
import Simulateur from "@/pages/Simulateur";
import Estimer from "@/pages/Estimer";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import DeposerAnnonce from "@/pages/DeposerAnnonce";
import Alertes, { UnsubscribeAlerte } from "@/pages/Alertes";
import { AgenceLanding, AgenceRegister, AgenceLogin, AgenceDashboard } from "@/pages/AgenceSpace";
import AvantagesInconvenients from "@/pages/AvantagesInconvenients";
import Philosophie from "@/pages/Philosophie";
import RevueDePresse from "@/pages/RevueDePresse";
import VentesRealisees from "@/pages/VentesRealisees";
import VendreEnVenteATerme from "@/pages/VendreEnVenteATerme";
import VilleVenteATerme from "@/pages/VilleVenteATerme";
import { MentionsLegales, CGU, Confidentialite } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/comment-ca-marche" element={<CommentCaMarche />} />
            <Route path="/annonces" element={<Annonces />} />
            <Route path="/annonces/:id" element={<AnnonceDetail />} />
            <Route path="/simulateur" element={<Simulateur />} />
            <Route path="/estimer" element={<Estimer />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/deposer-annonce" element={<DeposerAnnonce />} />
            <Route path="/alertes" element={<Alertes />} />
            <Route path="/alertes/unsubscribe" element={<UnsubscribeAlerte />} />
            <Route path="/agences" element={<AgenceLanding />} />
            <Route path="/agences/inscription" element={<AgenceRegister />} />
            <Route path="/agences/connexion" element={<AgenceLogin />} />
            <Route path="/agences/tableau-de-bord" element={<AgenceDashboard />} />
            <Route path="/avantages-inconvenients" element={<AvantagesInconvenients />} />
            <Route path="/notre-philosophie" element={<Philosophie />} />
            <Route path="/revue-de-presse" element={<RevueDePresse />} />
            <Route path="/ventes-realisees" element={<VentesRealisees />} />
            <Route path="/vendre-en-vente-a-terme" element={<VendreEnVenteATerme />} />
            <Route path="/vendre-vente-a-terme/:city" element={<VilleVenteATerme />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/cgu" element={<CGU />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
